export default __webpack_public_path__ + "44a8a5ad9610bf9b7330763e76dda720.jpg";